export default __webpack_public_path__ + "static/media/logo.71b0af3d.png";